import { httpRequest } from "../../../utils/HttpRequest";
import { IInAndOutList,IInAndOutSearch } from "./inAndOutTypes"
class InAndOutervice {
    async ioTotal(params: IInAndOutSearch) {
        const apiUrl = `/vrm-sa/statistics/ioTotal`;
        return await httpRequest.post<IInAndOutList>(apiUrl,params);
    }
}
export const inAndOutService = new InAndOutervice();
